import React from "react";
import styled from "styled-components";
import Image from "gatsby-image";
import Breakpoints from "../components/styles/Breakpoints";
import { Colors } from "../components/styles/Colors";

const Grid = styled.div`
  background: ${Colors.cream1};

  > div:first-child {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 10px;

    margin-bottom: 10px;
  }

  @media ${Breakpoints.tablet} {
    display: grid;
    grid-template-columns: 4fr 6fr;
    grid-column-gap: 40px;

    padding: 100px 0;

    > div:first-child {
      grid-template-columns: none;
      grid-row-gap: 40px;
      margin: 0;
    }
  }
`;

export default function StoryGrid({ images = [] }) {
  return (
    <Grid>
      <div>
        <Image fluid={images[0].fluid} />
        <Image fluid={images[1].fluid} />
      </div>
      <Image fluid={images[2].fluid} />
    </Grid>
  );
}
